import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { InterventionCenterStatistics as InterventionCenterStatisticsType } from '../../../common/types/statistics/fhbfStatistics';

type Props = {
  statistics: InterventionCenterStatisticsType;
};

function CounselingReasonStatistics({ statistics }: Props) {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0',
        padding: '20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack direction='column'>
        <Typography fontSize='1.2rem' fontWeight='bold' mb={2}>
          Anlass der Beratungsfälle
        </Typography>
        <Typography>Häusliche Gewalt: {statistics.numberOfDomesticViolence}</Typography>
        <Typography>Ex-Partner Stalking: {statistics.numberOfExPartnerStalking}</Typography>
      </Stack>
    </Paper>
  );
}

export default CounselingReasonStatistics;
